import { Fulfillment } from '@/shared/constants';
import type { IModelCart, TCartInitialData } from '@/shared/types/cart';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { TCartSlice } from './types';

const initialState: TCartSlice = {
  model: null,
  Fulfillment,

  orderTypes: {
    Service: '',
    Merchandise: '',
    Food: '',
  },
};

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setMain: (state, action: PayloadAction<TCartInitialData>) => {
      return { ...state, ...action.payload };
    },
    setModel: (state, action: PayloadAction<IModelCart>) => {
      return { ...state, model: action.payload };
    },
  },
});

export const { setMain, setModel } = mainSlice.actions;

export default mainSlice.reducer;
